// todo refactor complexity, that comes from legacy jobs app code base.
/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import wnumb from 'wnumb';
import textTransform from 'textTransform';

// DOVA currency mapping.
const currencySymbolsMap = {
  1: '£',
  2: 'US$',
  3: '€',
  4: 'AU$',
  5: '$',
  6: 'NZ$',
  7: 'Rs',
  8: 'DH',
  9: '$',
  10: 'QR',
  11: 'SR',
  12: 'MTn',
  13: '$',
  14: '$',
  15: '$',
  16: '$',
  17: '¥',
  18: 'Fr',
  19: 'CNY',
  20: 'kr.',
  21: 'SEK',
  22: 'S$',
  23: 'kr',
  24: 'HK$',
  25: 'KWD',
  27: 'RM',
  28: 'R$',
  29: 'TRY',
  30: 'BD',
  31: 'OMR',
  32: 'Kc',
  33: 'kr.',
  34: 'E£',
  35: 'Rs.',
  36: '?',
  37: '?',
  38: 'Br',
  39: 'GH?',
  40: 'KSh',
  41: 'MK',
  42: 'K',
  43: 'NPR',
  44: 'K',
  45: 'PHP',
  46: 'FRw',
  47: 'Le',
  48: 'R',
  49: 'TSh',
  50: 'THB',
  51: 'USh',
  52: 'ZK',
  53: 'Ft',
  54: 'PLN',
  55: '?',
  56: '?',
};

function formatSalary(value, Salary, currencySign) {
  const currency = currencySymbolsMap[Salary.CurrencyId]
    ? currencySymbolsMap[Salary.CurrencyId] : currencySign;
  let currencyPosition = {
    prefix: currency,
  };

  if (process.env.REACT_APP_COUNTRY === 'fr') {
    currencyPosition = {
      suffix: ` ${currency}`,
    };
  }

  const salaryFormat = wnumb({
    decimals: 0,
    thousand: process.env.REACT_APP_THOUSANDS_SEPARATOR ? process.env.REACT_APP_THOUSANDS_SEPARATOR : ',',
    ...currencyPosition,
  });

  const salaryHourlyFormat = wnumb({
    mark: process.env.REACT_APP_MARK_SEPARATOR ? process.env.REACT_APP_MARK_SEPARATOR : '.',
    decimals: 2,
    ...currencyPosition,
  });

  return (Salary.CompensationTypeId === '1')
    ? salaryHourlyFormat.to(parseFloat(value))
    : salaryFormat.to(parseFloat(value));
}

function salaryFormatter(jobData, listing = false, descriptionMeta = false) {
  const Salary = { ...jobData.Salary };
  const { currencySign } = { jobData };

  if (
    Salary.HideSallary
    || (Salary['@HideSalaryMin'] && Salary['@HideSalaryMin'] === 'true')
    || (Salary['@HideSalaryMax'] && Salary['@HideSalaryMax'] === 'true')
    || (Salary.HideSalaryMin && Salary.HideSalaryMin === 'true')
    || (Salary.HideSalaryMax && Salary.HideSalaryMax === 'true')
  ) {
    return null;
  }

  if (parseInt(Salary.SalaryMin, 10) === 0 && parseInt(Salary.SalaryMax, 10) === 0) {
    return null;
  }

  if (Salary.SalaryMin) {
    Salary.SalaryMin = formatSalary(parseFloat(Salary.SalaryMin), Salary, currencySign);
  }
  if (Salary.SalaryMax) {
    Salary.SalaryMax = formatSalary(parseFloat(Salary.SalaryMax), Salary, currencySign);
  }

  if (listing) {
    if (Salary.SalaryMin && Salary.SalaryMax && Salary.CompensationType) {
      return `${Salary.SalaryMin} - ${Salary.SalaryMax} ${textTransform(Salary.CompensationType)}`;
    }

    return '';
  }

  if (Salary.Rate) {
    if ((Salary.SalaryMin && Salary.SalaryMinSpecified === 'true') && (Salary.CompensationType && Salary.CompensationTypeSpecified === 'true')) {
      if (Salary.SalaryMax && (Salary.SalaryMin !== Salary.SalaryMax) && Salary.SalaryMaxSpecified === 'true') {
        return `${Salary.SalaryMin} - ${Salary.SalaryMax} ${textTransform(Salary.CompensationType)}, ${Salary.Rate}`;
      }

      return `${Salary.SalaryMin} ${textTransform(Salary.CompensationType)}, ${Salary.Rate}`;
    }

    if (descriptionMeta) {
      const currencySymbol = currencySymbolsMap[Salary.CurrencyId]
        ? currencySymbolsMap[Salary.CurrencyId] : currencySign;
      return currencySymbol + textTransform(Salary.Rate);
    }

    return textTransform(Salary.Rate);
  }
  if (Salary.SalaryMin && Salary.SalaryMinSpecified === 'true') {
    if (Salary.SalaryMin === Salary.SalaryMax && Salary.CompensationType) {
      return `${Salary.SalaryMin} ${textTransform(Salary.CompensationType)}`;
    }
    if ((Salary.SalaryMax && Salary.SalaryMaxSpecified === 'true') && Salary.CompensationType) {
      return `${Salary.SalaryMin} - ${Salary.SalaryMax} ${textTransform(Salary.CompensationType)}`;
    }
    if (Salary.CompensationType) {
      return `${Salary.SalaryMin} ${textTransform(Salary.CompensationType)}`;
    }

    return Salary.SalaryMin;
  }
  if (Salary.SalaryMax && Salary.SalaryMaxSpecified === 'true') {
    if (Salary.CompensationType) {
      return `${Salary.SalaryMax} ${textTransform(Salary.CompensationType)}`;
    }

    return Salary.SalaryMax;
  }

  return null;
}

export { salaryFormatter, formatSalary };
